import { render, staticRenderFns } from "./WineCreate.vue?vue&type=template&id=3b3bbb68"
import script from "./WineCreate.vue?vue&type=script&lang=ts"
export * from "./WineCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports